import React from 'react';
import { Card, Paragraph } from '@leafwell/components';
import Image from 'next/image';

import { useWordPressContext } from 'contexts/wordpress-provider';

import HeadingBody from './heading-body';

const CardEmpty: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { translations } = useWordPressContext();

  return (
    <Card {...{ className, rounded: true, size: 'large', variant: 'danger' }}>
      <Image src="/document.svg" width={30} height={39} alt="" />
      <div className="text-black">
        <HeadingBody
          {...{
            level: '4',
            title: translations['No results were found'],
          }}
        />
        <Paragraph>
          {
            translations[
              'We’re sorry, but we couldn’t find results, try doing a different search.'
            ]
          }
        </Paragraph>
      </div>
    </Card>
  );
};

export default CardEmpty;
